export default "__VITE_ASSET__CjKl2NVw__"